import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-product-cart" }
const _hoisted_2 = { class: "img-product" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "info-product" }
const _hoisted_5 = { class: "info-product__details" }
const _hoisted_6 = { class: "info-product__actions" }
const _hoisted_7 = { class: "info-product__quantity" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "button button-remove" }


import { useCartShoppingStore } from '@/store/cartshopping';

export default /*@__PURE__*/_defineComponent({
  __name: 'CardProductCart',
  props: {
    product: {
        type: Object,
        required: true
    }
},
  setup(__props) {

const cartShop = useCartShoppingStore();



function onChangeQuantity(id, e) {
    const existingProduct = cartShop.cart.find(item => item.id === id);
    if (existingProduct) {
        existingProduct.quantity = Number(e.target.value);
        return;
    }
}

function removeProductToCart(id: number) {
    cartShop.removeFromCart(id)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.product.img_product[0] || 'https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png',
        alt: __props.product.description_product_custom
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("aside", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(__props.product.name_product), 1),
        _createElementVNode("p", null, _toDisplayString(__props.product.description_product_custom), 1),
        _createElementVNode("p", null, "Marca: " + _toDisplayString(__props.product.brand_product), 1)
      ]),
      _createElementVNode("aside", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { for: "quantity" }, "Cantidad", -1)),
          _createElementVNode("input", {
            type: "number",
            class: "input-product__product__quantity",
            id: "quantity",
            value: __props.product.quantity,
            onChange: _cache[0] || (_cache[0] = (e) => onChangeQuantity(__props.product.id, e))
          }, null, 40, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = () => removeProductToCart(__props.product.id))
          }, "Quitar")
        ])
      ])
    ])
  ]))
}
}

})